export const tasksStub: any = [
  {
    title: 'PIES',
    date: '9.05.2017',
    percent: 38
  },
  {
    title: 'ACES',
    date: '9.05.2017',
    percent: 97
  }
];
